import { render } from "./AdvertStatsModal.vue?vue&type=template&id=2079b630"
import script from "./AdvertStatsModal.vue?vue&type=script&lang=js"
export * from "./AdvertStatsModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__